import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

/**
 * Generated class for the KarmaMilesPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'leaderboardCounts',
})
export class LeaderboardCountsPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: object, ...args) {
    console.log('previousRanks', value);
    const counts = _.countBy(value, r => {
      const num = _.toNumber(_.get(r, 'position'));
      if (num === 1) {
        return 1;
      } else if (num <= 10) {
        return 10;
      } else if (num <= 100) {
        return 100;
      }
    });
    console.log('previousRanks', counts);
    if (args[0] === '1') {
      return counts['1'];
    } else if (args[0] === '10') {
      return counts['10'];
    } else if (args[0] === '100') {
      return counts['100'];
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/leaderboard-counts/leaderboard-counts.ts